import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';

import { GoogleAuth, UserAuth, UserPassword, UserReset } from './types';

export class VoladeumAuth extends Axios {
  async login(payload: UserAuth): Promise<VoladeumResponse<string>> {
    return this.post<VoladeumResponse<string>>('/v1/auth/login', payload);
  }

  async guest(): Promise<VoladeumResponse<string>> {
    return this.get<VoladeumResponse<string>>('/v1/auth/guest');
  }

  async google(payload: GoogleAuth): Promise<VoladeumResponse<string>> {
    return this.post<VoladeumResponse<string>>('/v1/auth/google', payload);
  }

  async forgotPassword(payload: UserReset): Promise<VoladeumResponse<string>> {
    return this.post<VoladeumResponse<string>>('/v1/auth/password/forgot', payload);
  }

  async resendEmail(payload: UserReset): Promise<VoladeumResponse<string>> {
    return this.post<VoladeumResponse<string>>('/v1/auth/email/verify/resend', payload);
  }

  async resetPassword(code: string, payload: UserPassword): Promise<VoladeumResponse<string>> {
    return this.post<VoladeumResponse<string>>(`/v1/auth/password/reset/${code}`, payload);
  }
}
